// src/api/KnowledgePageApi.js
import axios from "axios";
import { ERROR_CODES } from '../constants/errors'; // Import error codes

const baseUrl = process.env.REACT_APP_BACKEND_URL || "http://localhost:5000";

export const fetchInfluencerAiSummary = async (token, influencerId) => {
  const url = `${baseUrl}/publications/api/aiSummary/${influencerId}`;
  try {
    const response = await axios.get(url, {
      headers: { Authorization: `Bearer ${token}` },
      validateStatus: (status) => status >= 200 && status < 500,
    });

    if (response.status === 200) {
      // Expecting an object like { aiSummary: "..." }
      return response.data;
    } else {
      return {
        error: response.data?.error || `HTTP_ERROR_${response.status}`,
        message: response.data?.message || `Failed to fetch AI summary (Status: ${response.status}).`,
        data: response.data?.data,
      };
    }
  } catch (error) {
    console.error("[fetchInfluencerAiSummary] Request error:", error);
    if (error.response) {
      return {
        error: error.response.data?.error || `HTTP_ERROR_${error.response.status}`,
        message: error.response.data?.message || "API request failed.",
        data: error.response.data?.data,
      };
    } else if (error.request) {
      return {
        error: ERROR_CODES.NETWORK_ERROR,
        message: "Network error: No response received from server.",
      };
    } else {
      return {
        error: ERROR_CODES.REQUEST_ERROR,
        message: error.message || "An unexpected error occurred during the request setup.",
      };
    }
  }
};

export const generateAISummary = async (token, params) => {
  const url = `${baseUrl}/publications/api/generateAISummary`;
  try {
    const response = await axios.post(url, params, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      validateStatus: (status) => status >= 200 && status < 500,
    });

    if (response.status === 200) {
      return response.data;
    } else {
      return {
        error: response.data?.error || `HTTP_ERROR_${response.status}`,
        message: response.data?.message || `Failed to generate AI summary (Status: ${response.status}).`,
        data: response.data?.data,
      };
    }
  } catch (error) {
    console.error("[generateAISummary] Request error:", error);
    if (error.response) {
      return {
        error: error.response.data?.error || `HTTP_ERROR_${error.response.status}`,
        message: error.response.data?.message || "API request failed.",
        data: error.response.data?.data,
      };
    } else if (error.request) {
      return {
        error: ERROR_CODES.NETWORK_ERROR,
        message: "Network error: No response received from server.",
      };
    } else {
      return {
        error: ERROR_CODES.REQUEST_ERROR,
        message: error.message || "An unexpected error occurred during the request setup.",
      };
    }
  }
};

export const updateAISummary = async (token, influencerId, aiSummary) => {
  const url = `${baseUrl}/publications/api/updateAISummary/${influencerId}`;
  try {
    const response = await axios.put(
      url,
      { aiSummary }, // Payload
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        validateStatus: (status) => status >= 200 && status < 500,
      }
    );

    if (response.status === 200) {
      // Expecting { message: "..." }
      return response.data;
    } else {
      return {
        error: response.data?.error || `HTTP_ERROR_${response.status}`,
        message: response.data?.message || `Failed to update AI summary (Status: ${response.status}).`,
        data: response.data?.data,
      };
    }
  } catch (error) {
    console.error("[updateAISummary] Request error:", error);
    if (error.response) {
      return {
        error: error.response.data?.error || `HTTP_ERROR_${error.response.status}`,
        message: error.response.data?.message || "API request failed.",
        data: error.response.data?.data,
      };
    } else if (error.request) {
      return {
        error: ERROR_CODES.NETWORK_ERROR,
        message: "Network error: No response received from server.",
      };
    } else {
      return {
        error: ERROR_CODES.REQUEST_ERROR,
        message: error.message || "An unexpected error occurred during the request setup.",
      };
    }
  }
};

